$(document).foundation();

$(document).ready(function($){
    if(('#slider-carousel').length){
        $('#slider-carousel').flickity({
            // options
            contain: true,
            cellSelector: '.slide',
            draggable: true,
            wrapAround: true,
            autoPlay: 8000,
            prevNextButtons: false
        });
    }

//     $('#cartBtn').hover(function(){
//        $('#cart-info').slideToggle();
//     });

    if($('.dropdown-toggle').length){
        $('.dropdown-toggle').parent().hover(function (){
            if( Foundation.MediaQuery.current > Foundation.MediaQuery.get('large') ){
                $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
            }
        }, function (){
            if(Foundation.MediaQuery.current > Foundation.MediaQuery.get('large') ){
                $(this).find('.dropdown-menu').hide();
            }
        });
    }
  
  $('#nav-close').click(function(){
  	
    $('.off-canvas').removeClass('is-open');
    $('.js-off-canvas-overlay').removeClass('is-visible');
    
  });
  
  

});
